export const getArticle = (word) => {
  const firstLetter = word.charAt(0).toLowerCase();
  const vowelSoundLetters = ['a', 'e', 'i', 'o', 'u'];
  if (vowelSoundLetters.includes(firstLetter)) {
    return 'an';
  }
  return 'a';
};

export const formatFileType = (format) => {
  if (format.toLowerCase() === 'excel') {
    return 'Excel';
  }
  return format.toUpperCase(); // Para 'csv', 'pdf', etc.
};

/**
 * Masks an email address for privacy
 * @param {string} email - The email to mask
 * @returns {string} Masked email (e.g., "a***@gmail.com")
 */
export const maskEmail = (email) => {
  if (!email || !email.includes('@')) return email;
  const [localPart, domain] = email.split('@');
  if (localPart.length <= 1) return email;
  return `${localPart[0]}***@${domain}`;
};
